<template>
    <div class="flex shrink-0 items-center gap-1 rounded-lg p-2 text-xs font-bold">
        <slot v-if="$slots.icon" name="icon" />

        <span class="text-nowrap"><slot /></span>
    </div>
</template>
<script setup></script>
